<script lang="ts">
	import type { Picture } from '../../interfaces/Picture';
	import { _ } from '../../utility-services/Translation.service';
	interface Props {
		picture: Picture;
		placeHolderIcon: string;
		dataposition: string;
	}

	let { picture = $bindable(), placeHolderIcon, dataposition = 'bottom-right' }: Props = $props();
</script>

<div
	class="vtmn-rounded-full vtmn-border-2 vtmn-h-7 vtmn-w-7 vtmn-border-border-secondary vtmn-text-center"
>
	<span
		class="vtmn-tooltip"
		data-tooltip={picture.title}
		data-position={dataposition}
		role="tooltip"
	>
		{#if picture?.src}
			<img
				class="vtmn-rounded-full"
				src={picture.src}
				alt={picture.alt}
				onerror={() => {
					picture.src = '';
				}}
			/>
		{:else}
			<span class="vtmn-sr-only">{$_('profile')}</span>
			<span
				class="{placeHolderIcon} vtmn-text-content-primary"
				style="font-size:xx-large;"
				aria-hidden="true"
			></span>
		{/if}
	</span>
</div>
